import React from 'react'

import { Forms } from '../FormFields'

const FormComponent = ({ errorMessage, initialValues }) => (
  <Forms values={initialValues} errorMessage={errorMessage} />
)

export default FormComponent
